module.exports = __webpack_public_path__ + "img/Sin tanto papeleo ni procesos engorrosos.ef4d24e9.svg";